import React, { useCallback } from 'react';
import classNames from 'classnames';

import ReactSlider from 'react-slider';
import { useSharePanelStore } from 'src/common/store/share.store';
import { Button } from 'src/common/button';

interface Props {
  onThumbnailUrlUpdate: (url: string) => void;
}

export const ShareThumbnailFrameSliderOverlay = ({ onThumbnailUrlUpdate }: Props) => {
  const { selectedImageUrl, onSliderUpdate, onSliderSelectionComplete } = useSharePanelStore((state) => ({
    selectedImageUrl: state.selectedImageUrl,
    onSliderUpdate: state.onSliderUpdate,
    onSliderSelectionComplete: state.onSliderSelectionComplete,
  }));

  const onConfirm = useCallback(() => {
    onThumbnailUrlUpdate(selectedImageUrl as string);
    onSliderSelectionComplete();
  }, [onSliderSelectionComplete, onThumbnailUrlUpdate, selectedImageUrl]);

  const onCancel = useCallback(() => {
    onSliderSelectionComplete();
  }, [onSliderSelectionComplete]);

  return (
    <div className={classNames('absolute inset-0 rounded-lg block bg-bedrock-black/backdrop')}>
      <div className='flex flex-col w-full h-full p-md justify-between relative'>
        <ReactSlider
          className='w-full relative h-2'
          min={0}
          max={14}
          onChange={onSliderUpdate}
          renderTrack={(props, state) => (
            <div {...props} className='bg-white bg-opacity-40 rounded-3xl h-0.5 mt-[3px]' />
          )}
          renderThumb={(props, state) => <div {...props} className='bg-white w-2 h-2 rounded-full' />}
        />
        <div className='flex items-start space-x-sm'>
          <Button size='regular' variant='secondary' label='Use thumbnail' onClick={onConfirm} />
          <Button size='regular' variant='tertiary' label='Cancel' className='text-bedrock-white' onClick={onCancel} />
        </div>
      </div>
    </div>
  );
};
